<template>
    <div class="bookConfigBatch-container app-container">
        <div class="bookConfigBatch-tag bg-white">
            <tag/>
        </div>

        <div class="app-table-container">
            <el-row :gutter="20">
                <el-col :span="12">
                    <dataTable :tableId="'table-first'" :tableData="tableData" :tableProps="tableProps1" :tableTitle="$t('org.selectedCX')">
                        <!-- <pagination
                        layout="prev, pager, next"
                        /> -->
                        
                    </dataTable>
                </el-col>
                <el-col :span="12">
                    <dataTable :tableId="'table-second'" :tableData="tableData" :tableProps="tableProps2" :tableTitle="$t('org.optionalCX')">
                        <!-- <pagination
                        layout="prev, pager, next"
                        /> -->
                        
                    </dataTable>
                </el-col>
            </el-row>
        </div>
        <div class="bookConfigBatch-btn">
            <button class="global-button-style">{{$t('commonMsg.save')}}</button>  
        </div>
    </div>
</template>

<script>
import tag from '@/components/tag'
import dataTable from '@/components/dataTable'
import pagination from '@/components/pagination'
export default {
    components: {
        tag,
        dataTable,
        pagination
    },
    computed: {
        tableProps1() {
            let tableProps1 = [{
                prop:'value',
                label: this.$t('org.library'),
            }, {
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                btn: [this.$t('commonMsg.remove')]
            }]
            return tableProps1
        },
        tableProps2() {
            let tableProps2 = [{
                prop:'value',
                label: this.$t('org.library'),
            }, {
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                btn: [this.$t('commonMsg.add')]
            }]
            return tableProps2
        }
    },
    data() {
        return {
            tableData:[{
                value:'校园阅读系统'
            }, {
                value:'家长学校'
            }, {
                value:'心理健康平台'
            }, {
                value:'党建'
            }]
        }
    }
}
</script>

<style lang="scss" scoped>
    .bookConfigBatch-tag{
        padding:10px 20px;
    }
    .bookConfigBatch-btn{
        text-align: center;
        margin-bottom: 20px;
        .global-button-style{
            width:140px;
        }
    }
</style>
